import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchDebtInformationsApi,
  addDebtInformationApi,
  updateDebtInformationApi,
  deleteDebtInformationApi,
} from "./debtInformationsApi";

const getErrorMessage = (error, defaultMsg) => {
  if (error.response?.data) {
    const data = error.response.data;
    if (typeof data === "string") return data;
    return data.ExceptionMessage || data.message || data.title || defaultMsg;
  }
  return "Bağlantı hatası";
};

export const fetchDebtInformations = createAsyncThunk(
  "debtInformations/fetch",
  async ({ branchId, transactionDate }, { rejectWithValue }) => {
    try {
      const data = await fetchDebtInformationsApi(branchId, transactionDate);
      return data.items || [];
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Geçiş borçları alınamadı."));
    }
  }
);

export const addDebtInformation = createAsyncThunk(
  "debtInformations/add",
  async (debtInfo, { rejectWithValue }) => {
    try {
      const data = await addDebtInformationApi(debtInfo);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Geçiş borcu eklenemedi."));
    }
  }
);

export const updateDebtInformation = createAsyncThunk(
  "debtInformations/update",
  async ({ id, debtInfo }, { rejectWithValue }) => {
    try {
      const data = await updateDebtInformationApi(id, debtInfo);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Geçiş borcu güncellenemedi."));
    }
  }
);

export const deleteDebtInformation = createAsyncThunk(
  "debtInformations/delete",
  async (id, { rejectWithValue }) => {
    try {
      await deleteDebtInformationApi(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Geçiş borcu silinemedi."));
    }
  }
);
